export const runFileDownload = (href: string, filename: string, extension = 'csv') => {
    const link = document.createElement('a');
    link.href = href;
    link.style.display = 'none';
    link.setAttribute('download', `${filename}.${extension}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
